<template>
  <div class="focused-panel">
    <div class="d-flex constraints-toolbar">
      <!--<div class="p-2">{{wellFeature ? wellFeature.get('ident') : 'No well selected'}}</div>-->
      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Create polygon" :pressed.sync="addPolyEnabled" variant="primary">
        <icon scale=".6" name="plus-square"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Create line" :pressed.sync="addLineEnabled" variant="primary">
        <icon scale=".6" name="plus"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Create point" :pressed.sync="addPointEnabled" variant="primary">
        <icon scale=".6" name="plus-circle"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Select constraint" :pressed.sync="selectEnabled" variant="primary">
        <icon scale=".6" name="hand-pointer"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" :id="'undo-'+editorIdent" :disabled="!historyChanges" @click="undo" variant="primary">
        <icon scale=".6" name="undo"/>
      </b-btn>
      <b-tooltip v-if="historyChanges" :target="'undo-'+editorIdent" placement="top">
        Undo
      </b-tooltip>


      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Edit geometry" :disabled="!wellFeatureSelected" :pressed.sync="dragEnabled"
             variant="primary">
        <icon scale=".6" name="arrows-alt"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Edit attributes" :disabled="!wellFeatureSelected" :pressed.sync="editEnabled"
             variant="primary">
        <icon scale=".6" name="pencil-alt"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" @click="deleteFetaures" v-b-tooltip.hover.auto title="Delete constraint" :disabled="!wellFeatureSelected"
             variant="primary">
        <icon scale=".6" name="times"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" :pressed.sync="ldEnabled" v-b-tooltip.hover.auto title="Load dependant layers"
             variant="primary">
        <icon scale=".6" name="link"/>
      </b-btn>

      <!--<b-btn :disabled="!hasChanges" variant="primary" @click="otfCommentShow=true">-->
      <!--<icon :name="saving ? 'spinner' : 'save'" :pulse="saving"/>-->
      <!--</b-btn>-->
    </div>

    <b-modal v-model="showForm" @ok="onOK" @cancel="onCancel" size="lg">
      <div slot="modal-header">
        <label>{{formTitle}}</label>
      </div>
      <constraints-form v-model="wellAttrs" :options="options" :featureId="featureId" :causes="causes" :type="geomType"/>
    </b-modal>

  </div>
</template>

<script>
  import 'vue-awesome/icons/arrows-alt'
  import 'vue-awesome/icons/times'
  import 'vue-awesome/icons/plus'
  import 'vue-awesome/icons/save'
  import 'vue-awesome/icons/check'
  import 'vue-awesome/icons/plus-square'
  import 'vue-awesome/icons/plus-circle'
  import Vue from 'vue'

  import FeatureEditorMixin from '../../../mixins/FeatureEditorMixin'
  import ConstraintsForm from './ConstraintsForm'
  import uuidV1 from 'uuid/v1'

  export default {
    name: 'constraints-editor',
    components: {
      ConstraintsForm
    },
    mixins: [FeatureEditorMixin],
    data () {
      return {
        featureId: null,
        addPolyEnabled: false,
        addLineEnabled: false,
        addPointEnabled: false,
        wellAttrs: {
          major: null,
          minor: '',
          photos: null,
          buffer_dist_m: null,
          comments: null,
          cause: []
        },
        options: [],
        causes: [],
        wellLayerName: 'v4:constraints_landholder',

        geometryName: 'geo',
        idName: 'gid'
      }
    },
    mounted () {
      Vue.nextTick(() => {
        this.$options.mixins[0].mounted.call(this)
        this.loadOptions()
        this.loadCauses()
      })
    },
    methods: {
      editProps (feature) {
        this.featureId = feature.get('gid')
        FeatureEditorMixin.methods.editProps.call(this, feature)
      },
      addFeature (e) {
        this.formTitle = 'Create constraint'

        // QUICK FIX for model not clearing on save, force clear
        // this.wellAttrs = {
        //   major: null,
        //   minor: '',
        //   photos: null,
        //   buffer_dist_m: null,
        //   comments: null,
        //   cause: []
        // }

        this.showForm = true
        this.wellFeature = e.feature.clone()
        this.drawingFeature = e.feature
        this.wellFeature.set('ident', `${this.editorIdent}-${uuidV1()}`)
        this.wellFeature.set('workpack_id', this.currentProject.workpack.id)
      },
      loadOptions () {
        this.$http.get('/api/layers/get-constraints-options/')
          .then(res => {
            this.options = res.body
          }, res => {
            this.$notify({
              title: 'ERROR',
              text: 'Could not get constraints categories',
              type: 'error'
            })
          })
      },
      loadCauses () {
        this.$http.get('/api/layers/get-constraints-causes/')
          .then(res => {
            this.causes = res.body['causes'].split(',').map(c => {
              return {
                text: c.trim(),
                value: c.trim()
              }
            })
          }, res => {
            this.$notify({
              title: 'ERROR',
              text: 'Could not get constraints causes',
              type: 'error'
            })
          })
      }
    },
    watch: {
      currentEditor (val) {
        if (val !== this.editorIdent) {
          this.addEnabled = false
          this.selectEnabled = false
          this.addLineEnabled = false
          this.addPointEnabled = false
          this.addPolyEnabled = false
        }
      },
      selectTool (val) {
        if (val) {
          this.addLineEnabled = false
          this.addPointEnabled = false
          this.addPolyEnabled = false
        }
      },
      addPolyEnabled (val) {
        if (val) {
          this.addLineEnabled = false
          this.addPointEnabled = false
          this.geomType = 'Polygon'
          Vue.nextTick(() => {
            this.addEnabled = true
          })
        } else {
          this.addEnabled = false
        }

      },
      addLineEnabled (val) {
        if (val) {
          this.addPolyEnabled = false
          this.addPointEnabled = false
          this.geomType = 'LineString'
          Vue.nextTick(() => {
            this.addEnabled = true
          })
        } else {
          this.addEnabled = false
        }

      },
      addPointEnabled (val) {
        if (val) {
          this.addPolyEnabled = false
          this.addLineEnabled = false
          this.geomType = 'Point'
          Vue.nextTick(() => {
            this.addEnabled = true
          })
        } else {
          this.addEnabled = false
        }

      }
    },
    computed: {
      selectTool () {
        return this.selectEnabled
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/map/designotron/ConstraintsEditor.vue